import { Button } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PERMISSIONS } from '../../../../../consts/permissions';
import { useAuth } from '../../../../../hooks/useAuth';
import { SearchCircleOutLined } from '../../../../../icons/search-circle-outlined';
import { X } from '../../../../../icons/x';
import STRING_KEYS from '../../../../../language/keys';
import { style } from './style';

type RunActionsProps = {
  onRunClick: () => void,
  isMatchFlowRunLoading: boolean,
  isMatchFlowRunning: boolean,
  isMatchFlowCancelLoading: boolean,
  onAbortRunSearchClick: () => void,
}

export const RunActions = ({
  onRunClick,
  isMatchFlowRunning,
  isMatchFlowRunLoading,
  isMatchFlowCancelLoading,
  onAbortRunSearchClick,
}: RunActionsProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const { hasPermissions } = useAuth();

  const defineRunButton = () => {
    if (!hasPermissions([PERMISSIONS.MATCH_FLOW_RUN])) {
      return null;
    }

    if (!isMatchFlowRunning) {
      return (
        <Button
          variant="contained"
          color="secondary"
          onClick={ () => onRunClick() }
          sx={ style.button.sx }
          disabled={ isMatchFlowRunLoading }
          startIcon={
            <SearchCircleOutLined />
          }
        >
          {translate(STRING_KEYS.RUN_SEARCH)}
        </Button>
      );
    }

    return (
      <Button
        variant="contained"
        onClick={ onAbortRunSearchClick }
        sx={ style.buttonX.sx }
        disabled={ isMatchFlowCancelLoading }
        startIcon={
          <X fontSize="inherit" />
        }
      >
        {translate(STRING_KEYS.CANCEL_SEARCH)}
      </Button>
    );
  };

  return (
    <Box>
      {defineRunButton()}
    </Box>
  );
};
